module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SocialApps

(function (fox, $) {
	
	fox.registerWidget('SocialApps', {

		configure: function () {
			this.registerOptions('', {
				skipPreloader: true,
				appDomElementOptions: {},
				targetInNewWindow: true,
				drawImage: true,
				imageLocation: 'social_icons',
				'embed.container': '.social',
				dataLayer: '#appsDatalayer',
				list: {
					'tpl.row': 'social_apps_row',
					'hooks.onStartRendering': '@parent:prepareCollection'
				},
				widgets: {
					appsDatalayer: {
						widget: 'Datalayer',
						method: 'SocialNetwork.getActiveList',
						cacheChannel: 'site'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._appDomElementOptions = {
				twitter: {
					linkClass: this.getOption('appDomElementOptions.twitter.linkClass') || 'twitter',
					imageName: this.getOption('appDomElementOptions.twitter.imageName') || 'ico-tw.png'
				},
				facebook: {
					linkClass: this.getOption('appDomElementOptions.facebook.linkClass') || 'facebook',
					imageName: this.getOption('appDomElementOptions.facebook.imageName') || 'ico-fb.png'
				},
				instagram: {
					linkClass: this.getOption('appDomElementOptions.instagram.linkClass') || 'instagram',
					imageName: this.getOption('appDomElementOptions.instagram.imageName') || 'ico-insta.png'
				},
				tumblr: {
					linkClass: this.getOption('appDomElementOptions.tumblr.linkClass') || 'tumblr',
					imageName: this.getOption('appDomElementOptions.tumblr.imageName') || 'ico-t.png'
				},
				googlePlus: {
					linkClass: this.getOption('appDomElementOptions.googlePlus.linkClass') || 'google-plus',
					imageName: this.getOption('appDomElementOptions.googlePlus.imageName') || 'ico-gp.png'
				},
				youtube: {
					linkClass: this.getOption('appDomElementOptions.youtube.linkClass') || 'youtube',
					imageName: this.getOption('appDomElementOptions.youtube.imageName') || 'ico-yt.png'
				}
			}
		
			this.callParent('init', arguments);
		},

		prepareCollection: function () {
			var _res, _appName, performer, checkInsta;


			performer = this.rwom1('#appsDatalayer');
			checkInsta = fox.getEnv('instagramUrl') || false
			_res = performer.getCollection();
			this.getInstaforKey(_res)
			_res.inst = {}
			_res.inst = checkInsta ? {alias: "instagram", pageUrl: checkInsta, title: "Instagram"} : false
			
			fox.each(_res, function (_val, _key) {
				_appName = _val.alias;

				if (this._appDomElementOptions.hasOwnProperty(_appName)) {
					_val.elementClass = this._appDomElementOptions[_appName]['linkClass'];

					if (this.getOption('drawImage') === true) {
						_val.socImage = 
							fox._isNewFe ? 
								require('../images/social_icons/' + this._appDomElementOptions[_appName]['imageName']) : 
									fox.getEnv('design.url') + '/images/' + this.getOption('imageLocation') + '/' + this._appDomElementOptions[_appName]['imageName'];
					}

					if (this.getOption('targetInNewWindow') === true) {
						_val.newTarget = true;
					}
				}
			}, this);
			
			performer.setCollection(_res);
		},
		getInstaforKey: function (obj) {
			var _key = fox.getObjectKeys(obj);
			fox.each(_key, function (item) {
				if (obj[item].title === "Instagram"){
					delete obj[item]
				}
			})
			return obj;
		}
	}, 'Grid');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/socialapps.js
// module id = 938
// module chunks = 4